import { IMG_BASE } from './constants.js';

export const districts = [
    {
        id: '1ku',
        name: 'District01 | Trend Spark',
        description: 'インスピレーションを刺激する、最新のトレンド情報',
        color: '#dfd000',
        imageSrc: `${IMG_BASE}/district-1ku.webp`,
        left: 1005.8,
        top: 377.0,
        width: 497.5,
        height: 360.0,
        pinPoint: { x: 1245.3, y: 403.8 },
        panPoint: { x: 1245.3, y: 523.9 },
    },
    {
        id: '2ku',
        name: "District02 | Men's Skin Metrics",
        description: '男性の肌・美容に関する知識を、基礎から最先端まで発信',
        color: '#1dbfc1',
        imageSrc: `${IMG_BASE}/district-2ku.webp`,
        left: 783.0,
        top: 520.4,
        width: 503.8,
        height: 332.4,
        pinPoint: { x: 1034.4, y: 625.4 },
        panPoint: { x: 1032.0, y: 693.5 },
    },
    {
        id: '3ku',
        name: 'District03 | Derma Science',
        description: '皮膚科学を学び、正しい選択眼を身に付ける',
        color: '#2c7ad7',
        imageSrc: `${IMG_BASE}/district-3ku.webp`,
        left: 531.2,
        top: 264.2,
        width: 502.0,
        height: 377.5,
        pinPoint: { x: 780.9, y: 331.1 },
        panPoint: { x: 780.9, y: 421.3 },
    },
    {
        id: '4ku',
        name: 'District04 | Color Gallery',
        description: '美とアートが交差する、ユニークな情報体験',
        color: '#df4646',
        imageSrc: `${IMG_BASE}/district-4ku.webp`,
        left: 973.2,
        top: 125.8,
        width: 745.5,
        height: 431.6,
        pinPoint: { x: 1393.5, y: 166.0 },
        panPoint: { x: 1392.8, y: 299.5 },
    },
    {
        id: '5ku',
        name: 'District05 | Borderless Beauty',
        description: '先入観に囚われない、自由な選択肢や価値観を提案',
        color: '#67c688',
        imageSrc: `${IMG_BASE}/district-5ku.webp`,
        left: 1419.0,
        top: 465.0,
        width: 533.0,
        height: 430.7,
        pinPoint: { x: 1815.4, y: 469.6 },
        panPoint: { x: 1816.2, y: 584.8 },
    },
    {
        id: '6ku',
        name: 'District06 | Wellness Lab',
        description: '心と身体を整え、健やかな美しさに導くメソッドを発信',
        color: '#e548e5',
        imageSrc: `${IMG_BASE}/district-6ku.webp`,
        left: 741.2,
        top: 796.4,
        width: 786.2,
        height: 339.2,
        pinPoint: { x: 1126.8, y: 976.3 },
        panPoint: { x: 1137.6, y: 1028.2 },
    },
    {
        id: '7ku',
        name: 'District07 | Sustainability',
        description: '環境配慮や社会貢献の取り組みを紹介',
        color: '#ff7703',
        imageSrc: `${IMG_BASE}/district-7ku.webp`,
        left: 267.0,
        top: 425.0,
        width: 1784.0,
        height: 484.3,
        pinPoint: { x: 601.2, y: 625.5 },
        panPoint: { x: 556.4, y: 709.3 },
    },
];
